(function($) {
  const $dropdown = $('.dropdown-archives')
  $dropdown.each(function(i, el) {
    let activeText = $(el).find('.dropdown-menu .active').text();
    if (activeText) {
      $(el).addClass('active-filter')
      $(el).find('.dropdown-toggle .text').text(activeText)
    }
  })
})(jQuery);